import InputGroupForm from '@/components/InputGroupForm.vue'
import sportsmanService from "@/utils/services/sportsmanService";
import global from "@/utils/global";
import FormSelectVue from "@/components/resultTeam/FormSelectVue.vue";
import DisciplineDataService from "@/utils/services/disciplineService";
import SportsmanService from "@/utils/services/sportsmanService";

export default {
  name: 'peopleSportEdit',
  components: {FormSelectVue, InputGroupForm},
  props: {
    editItem: {
      fio: null,
      birthDay: null,
      gender: null,
      schoolId: null,
      federationId: null,
      rankId: null,
      localityId: null,
      bestEventId: null,
      teamId: null,
      secondLocalityId: null,
      trainerId: null,
      address: null,
      peoplePostId: null
    },
    fedList: [],
    stageTrainingList: [],
    rankList: [],
    ageKindList: [],
    peoplePostList: [],
    localityList: [],
    schoolList: [],
    structureTeamList: [],
    teamList: [],
    bestEventList: [],
    secondLocalityList: [],
    captionForm: 'Редактировать'
  },
  watch: {
    'selectedItem.federationId': function (val) {
      if (val === null || val === undefined) {
        this.disciplineList = []
        this.trainerList = []
      } else {
        this.loadDisciplines(val)
        this.loadTrainersAll(val)
      }
    }
  },
  data() {
    return {
      trainerList: [],
      disciplineList: [],
      modalEditOpened: false,
      isLoading: false,
      confirm_dialog: false,
      selectedItem: {
        fio: null,
        birthDay: null,
        gender: null,
        schoolId: null,
        sportKindId: null,
        federationId: null,
        rankId: null,
        localityId: null,
        ageKindId: null,
        peoplePostId: null,
        address: null,
        disciplineId: null,
        stageTrainingId: null,
        teamId: null,
        trainerId: null,
        secondLocalityId: null,
        bestEventId: null,
        trainerFlg: false,
        teamFlg: true,
        structureTeam: null
      },
      validValue: {
        fio: true,
        gender: true,
        birthDay: true,
        federation: true,
        form: true,
      },
      genders: [
        {value: 'MAN', text: 'МУЖ'},
        {value: 'WOMAN', text: 'ЖЕН'},
      ],
      isTrueFalseOptions: [
        {value: false, text: 'Нет'},
        {value: true, text: 'Да'}
      ]
    }
  },
  methods: {
    saveSportsman() {
      this.checkValidForm()
      if (this.validValue.form) {
        let vm = this
        sportsmanService.saveSportsman(this.selectedItem)
        .then((res) => {
          vm.modalEditOpened = false
          if (res.data != null) {
            vm.$emit('saveItem', res.data, vm.selectedItem.id == null)
          }
        })
        .finally(() => vm.cleanItem())
      }
    },
    checkValidForm() {
      for (var key in this.validValue) {
        this.validValue[key] = true;
      }
      if (global.nullOrMinus(this.selectedItem.federationId)) {
        this.validValue.federation = false;
        this.validValue.form = false;
      }
      if (!this.selectedItem.fio || this.selectedItem.fio === '') {
        this.validValue.fio = false;
        this.validValue.form = false;
      }
      if (!this.selectedItem.gender || this.selectedItem.gender === '') {
        this.validValue.gender = false;
        this.validValue.form = false;
      }
      if (!this.selectedItem.birthDay || this.selectedItem.birthDay === '') {
        this.validValue.birthDay = false;
        this.validValue.form = false;
      }
    },
    showConfirmDlg() {
      this.confirm_dialog = true;
    },
    deleteSportsman() {
      sportsmanService.deleteSportsman(this.selectedItem.id)
      .then((res) => {
        this.confirm_dialog = false
        this.modalEditOpened = false
        this.$emit('deleteItem', this.selectedItem.id)
      })
      .finally(() => this.cleanItem())
    },
    loadDisciplines(fedId) {
      this.disciplineList = [];
      var vm = this;
      DisciplineDataService.getDisciplineListByFederation(fedId)
      .then((response) => {
        vm.disciplineList = response.data
      })
      .catch((error) => console.log(error.message));
    },
    showEditForm(id, fedId, isClearId) {
      if (id != null) {
        this.isLoading = true
        sportsmanService.getSportsman(id).then((res) => {
          this.selectedItem = res.data;
          if (isClearId) {
            this.selectedItem.id = null
            this.selectedItem.fio = this.selectedItem.fio + ' (COPY)'
          }
        }).finally(() => this.isLoading = false)
      } else {
        this.cleanItem()
        this.selectedItem.federationId = fedId
        this.selectedItem.gender = 'MAN'
        this.selectedItem.teamFlg = true
        this.selectedItem.trainerFlg = false
      }
      this.modalEditOpened = true
    },
    loadTrainersAll(federationId) {
      var vm = this;
      vm.trainerList = []
      SportsmanService.getSportsmanTrainers(federationId)
          .then((response) => {
              vm.trainerList = response.data;
          })
          .catch((error) => console.log(error.message));
    },
    cleanItem() {
      for (let key in this.selectedItem) {
        if (typeof this.selectedItem[key] == 'string') {
          this.selectedItem[key] = null
        } else if (typeof this.selectedItem[key] == 'array') {
          this.selectedItem[key] = []
        } else {
          this.selectedItem[key] = null
        }
      }
    }
  }
}
